import React from "react";
import { getCaseLink, getProductData, getProductNameBy } from "../../../services/productService";
import InquiryToCustomerOverviewBox from "./InquiryToCustomerOverviewBox";
import Container from "../../Container/Container";
import { useQuery } from "@tanstack/react-query";
import { fetchResource, queryKeys } from "../../../services/reactQuery/reactQueryService";
import { useInquiryToCustomer } from "@/src/hooks/queries/inquiryToCustomer";
import useProductParams from "../../../hooks/useProductParams";
import LegalbirdLoader from "../../ContentLoader/LegalbirdLoader";
import { InquiryToCustomerStatus } from "../../../types/Entities/InquiryToCustomer";
import { Navigate, useParams } from "react-router";
import InquiryToCustomerBox from "./InquiryToCustomerBox";

export default function InquiryToCustomer() {
  const { productName, productId } = useProductParams();
  const { inquiryId } = useParams();
  const convertedInquiryId = parseInt(inquiryId || "0");
  const productClassName = getProductNameBy("urlPartShort", productName);
  const productApiUri = getProductData(productClassName, "apiUri");

  const { data: product } = useQuery({
    queryKey: queryKeys.item(productApiUri, productId),
    queryFn: () => fetchResource(productApiUri, productId)
  });
  const { data: inquiry, isFetching } = useInquiryToCustomer(convertedInquiryId, !!(product && convertedInquiryId));

  if (!product || isFetching) {
    return <LegalbirdLoader centered />;
  }

  if (!inquiry || ![InquiryToCustomerStatus.STATUS_OPEN, InquiryToCustomerStatus.STATUS_OVERDUE].includes(inquiry.status)) {
    return <Navigate to={getCaseLink(product)} />;
  }

  return (
    <>
      {[InquiryToCustomerStatus.STATUS_OPEN, InquiryToCustomerStatus.STATUS_OVERDUE].includes(inquiry.status) && (
        <InquiryToCustomerOverviewBox inquiryToCustomer={inquiry} />
      )}
      <InquiryToCustomerBox inquiryToCustomer={inquiry} product={product} />
    </>
  );
}
